import React from 'react'
import Card from './styled-components/Card'
import HeaderText from './styled-components/HeaderText'
import HeaderTextSmall from './styled-components/HeaderTextSmall'
import { AnovaLogoSmall } from './AnovaLogo'
import TextColumn from './styled-components/TextColumn'
import { TermsOfServiceAndPrivacyPolicy } from './TermsOfServiceAndPrivacyPolicy'
import { analyticsPage } from '../analytics'

const VerifyEmailSuccess = () => {
  analyticsPage('ALI Log In - Email Verification Success')

  return (
    <Card data-verify-email-success>
      <div>
        <AnovaLogoSmall />
      </div>

      <TextColumn>
        <HeaderText>Success!</HeaderText>
        <HeaderTextSmall>Your email has been confirmed. </HeaderTextSmall>
      </TextColumn>

      <TermsOfServiceAndPrivacyPolicy />
    </Card>
  )
}

export default VerifyEmailSuccess
